var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["useDrag"]: () => __WEBPACK_EXTERNAL_MODULE_react_dnd_48e2fd05__.useDrag, ["useDrop"]: () => __WEBPACK_EXTERNAL_MODULE_react_dnd_48e2fd05__.useDrop });